/* VertiHerbe – à la première visite, passe automatiquement dans la langue du navigateur et la devise du pays du visiteur
   (France : français + €, États-Unis : anglais + $, Allemagne : allemand + €…). Une seule fois : ensuite, le choix du visiteur
   (sélecteurs de pays et de langue) est toujours respecté. Les robots des moteurs de recherche ne sont jamais redirigés. */
(function () {
  var KEY = 'vh-localized';
  try { if (localStorage.getItem(KEY)) return; localStorage.setItem(KEY, '1'); } catch (e) { return; }
  if (!window.fetch || !window.Shopify || navigator.webdriver || /bot|crawl|spider|slurp|lighthouse|headless|preview/i.test(navigator.userAgent)) return;
  var root = (Shopify.routes && Shopify.routes.root) || '/';
  var country = Shopify.country || '', language = Shopify.locale || '';
  fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' + encodeURIComponent(country) +
    '&language[enabled]=true&language[exclude]=' + encodeURIComponent(language), { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var s = data && data.suggestions && data.suggestions[0];
      if (!s || !s.parts) return;
      var c = s.parts.country && s.parts.country.handle, l = s.parts.language && s.parts.language.handle;
      if ((!c || c === country) && (!l || l === language)) return;
      var path = location.pathname;
      if (root !== '/' && path.indexOf(root) === 0) path = '/' + path.slice(root.length);
      var f = document.createElement('form');
      f.method = 'POST'; f.action = '/localization'; f.hidden = true;
      [['form_type', 'localization'], ['_method', 'PUT'], ['country_code', c || country], ['language_code', l || language], ['return_to', path + location.search]]
        .forEach(function (kv) { var i = document.createElement('input'); i.type = 'hidden'; i.name = kv[0]; i.value = kv[1]; f.appendChild(i); });
      document.body.appendChild(f);
      f.submit();
    })
    .catch(function () {});
})();